module.exports = __webpack_public_path__ + "img/logo.9904db1c.png";